/* eslint-disable @typescript-eslint/no-explicit-any */

import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type VisitaEstaEnStockArgs = {
  marca: string;
  numero: string;
};

type VisitaEstaEnStockResponse = {
  state: number;
  value: boolean;
};

export const visitaEstaEnStock = async ({
  marca,
  numero,
}: VisitaEstaEnStockArgs): Promise<VisitaEstaEnStockResponse['value']> => {
  try {
    const res = await apiClient.post<any>(Endpoints.VisitaEstaEnStock, {
      marca,
      numero,
    });
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
